import React, { createContext, useContext, useState } from 'react'
import * as Localization from 'expo-localization'
import es from '../../../translations/es/es.js'
import en from '../../../translations/english/en.js'
import ar from '../../../translations/arabe/ar.js'
import az from '../../../translations/azeri/az.js'
import fr from '../../../translations/frances/fr.js'
import hi from '../../../translations/hindi/hi.js'
import id from '../../../translations/indonesio/id.js'
import kk from '../../../translations/kazajo/kk.js'
import pt from '../../../translations/portugues/pt.js'
import ru from '../../../translations/ruso/ru.js'
import tr from '../../../translations/turco/tr.js'
import uz from '../../../translations/uzbeko/uz.js'
import vi from '../../../translations/vi/vi.js'

const LocalizationStatePro = createContext()

export const LocalizationState = ({ children }) => {
    const setlanguageFile = (languageCode) => {
        switch (languageCode) {
            case 'es':
                return es
            case 'en':
                return en
            case 'ar':
                return ar
            case 'az':
                return az
            case 'fr':
                return fr
            case 'hi':
                return hi
            case 'id':
                return id
            case 'kk':
                return kk
            case 'pt':
                return pt
            case 'ru':
                return ru
            case 'tr':
                return tr
            case 'uz':
                return uz
            case 'vi':
                return vi
            default:
                return en
        }
    }
    const [languageFile] = useState(setlanguageFile(Localization.getLocales()[0].languageCode))

    const value = {
        languageFile,
        setlanguageFile,
    }
    return <LocalizationStatePro.Provider value={value}>{children}</LocalizationStatePro.Provider>
}

export const getLanguage = () => {
    return useContext(LocalizationStatePro)
}
